module.exports = __webpack_public_path__ + "static/a-xx-151-art-422118a4c2c89851d8e180d591dc2e10.jpg";